import { render, staticRenderFns } from "./ClickAndCollectAddress.vue?vue&type=template&id=4ff82170&"
import script from "./ClickAndCollectAddress.vue?vue&type=script&lang=ts&"
export * from "./ClickAndCollectAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ClickAndCollectAddress.vue?vue&type=style&index=0&id=4ff82170&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports